module.exports = __webpack_public_path__ + "static/img/pe.ea95116f.svg";